import { render, staticRenderFns } from "./DeletePrinterDialog.vue?vue&type=template&id=4ca2f6d7&scoped=true"
import script from "./DeletePrinterDialog.vue?vue&type=script&lang=js"
export * from "./DeletePrinterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca2f6d7",
  null
  
)

export default component.exports